const user_scopes = {
    descriptions: {
        custom_data: 'ข้อมูลที่กำหนดเองของคุณ',
        email: 'ที่อยู่อีเมลของคุณ',
        phone: 'หมายเลขโทรศัพท์ของคุณ',
        profile: 'ชื่อ ชื่อผู้ใช้ รูปประจำตัว และข้อมูลโปรไฟล์อื่น ๆ ของคุณ',
        roles: 'บทบาทของคุณ',
        identities: 'บัญชีโซเชียลที่เชื่อมต่อของคุณ',
        'urn:logto:scope:organizations': 'ข้อมูลองค์กรของคุณ',
        'urn:logto:scope:organization_roles': 'บทบาทในองค์กรของคุณ',
        address: 'ที่อยู่ของคุณ',
        'urn:logto:scope:sessions': 'เซสชันที่ใช้งานอยู่ของคุณ',
        'urn:logto:scope:trusted_devices': 'อุปกรณ์ที่เชื่อถือได้ของคุณ',
        'urn:logto:scope:personal_access_tokens': 'โทเค็นการเข้าถึงส่วนบุคคลของคุณ',
    },
};
export default Object.freeze(user_scopes);
